var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "Reports__Import__View" }, [
    _c("h1", [_vm._v("עדכון חוק/חוקים חסרים לתרגול")]),
    _c("div", { staticClass: "Reports__Import__View__Steps" }, [
      _c(
        "div",
        { staticClass: "loading" },
        [
          _c("b-loading", {
            attrs: { "is-full-page": true, "can-cancel": false },
            model: {
              value: _vm.isLoading,
              callback: function ($$v) {
                _vm.isLoading = $$v
              },
              expression: "isLoading",
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        [
          _c(
            "b-field",
            { attrs: { label: "עדכון חוקים חסרים לתרגול" } },
            [
              _c("b-button", { on: { click: _vm.updateExercises } }, [
                _vm._v(" עדכון "),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        [
          _c(
            "b-field",
            { attrs: { label: "עדכון חוק לתרגול בודד" } },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.exerciseId,
                    expression: "exerciseId",
                  },
                ],
                attrs: { type: "number", placeholder: "מספר התרגול" },
                domProps: { value: _vm.exerciseId },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.exerciseId = $event.target.value
                  },
                },
              }),
              _c("b-button", { on: { click: _vm.updateExercise } }, [
                _vm._v("עדכון"),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }